import { COLORS } from "@/constants";

export const NavigationArrowRight = ({ disabled }: { disabled?: boolean }) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 17L15 12" stroke={disabled ? COLORS['neutral/700'] : "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M15 12L10 7" stroke={disabled ? COLORS['neutral/700'] : "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg>